export default {"src":"/_next/static/media/icon-trash.da1766c3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};